module.exports = __webpack_public_path__ + "static/media/link.b6f6a8ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/link.svg
// module id = 458
// module chunks = 0